/*
  GM — «Completa il tuo kit» nel carrello.

  Il contenuto lo disegna Liquid (snippets/gm-kit-carrello.liquid) con il
  carrello del momento. Questo file fa tre cose sole:
    1. ogni volta che il carrello cambia richiede di nuovo la sezione
       gm-kit-carrello con la Section Rendering API, cosi' le righe gia'
       aggiunte si segnano e il kit segue l'attrezzo giusto (e sparisce del
       tutto quando nel carrello ci sono due attrezzi: la sezione torna vuota);
    2. il menu «Seleziona un altro ...» e il colore, che cambiano la riga
       (e l'asta, le lame o le catene che dipendono dal modello) senza
       ricaricare niente, prezzo barrato compreso;
    3. «Aggiungi», che passa dal Cart del tema: in questo modo il cassetto
       ridisegna i suoi articoli come dopo un'aggiunta dalla scheda prodotto.

  I prezzi arrivano gia' formattati da Liquid (filtro money del negozio):
  qui non si calcola ne' si formatta nessun importo.
*/
import Cart from "cart-store";

const SEZIONE = "gm-kit-carrello";
let richiesta = null;

function radice() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
}

/* Cassetto e pagina carrello possono esserci tutti e due: una richiesta sola. */
function prendiSezione() {
  if (!richiesta) {
    richiesta = fetch(radice() + "?sections=" + SEZIONE, { headers: { Accept: "application/json" } })
      .then((r) => {
        if (!r.ok) throw new Error("gm-kit-carrello " + r.status);
        return r.json();
      })
      .then((j) => (j && j[SEZIONE]) || "")
      .finally(() => {
        setTimeout(() => { richiesta = null; }, 0);
      });
  }
  return richiesta;
}

function leggiJSON(kit, sel) {
  const el = kit.querySelector(sel);
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
}

class GmKitCarrello extends HTMLElement {
  connectedCallback() {
    if (!this._ascolta) {
      this._ascolta = true;
      this.addEventListener("click", (e) => this.clic(e));
      this.addEventListener("change", (e) => this.cambio(e));
    }
    this._sub = Cart.subscribe((s, prima) => {
      if (s.cart !== prima.cart) this.pianifica();
    });
    if (this.hasAttribute("data-pronto")) {
      this.prepara(null);
    } else {
      this.pianifica(0);
    }
  }

  disconnectedCallback() {
    if (this._sub) { this._sub(); this._sub = null; }
    clearTimeout(this._t);
  }

  pianifica(ms) {
    clearTimeout(this._t);
    this._t = setTimeout(() => this.carica(), ms === undefined ? 120 : ms);
  }

  async carica() {
    let html;
    try { html = await prendiSezione(); } catch (e) { return; }
    const stato = this.leggiStato();
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const nuovo = tmp.querySelector("[data-gmkc]");
    /* Senza kit (due attrezzi, o solo un'asta) il contenitore resta vuoto:
       niente titolo orfano, niente filetto, niente spazio. */
    if (nuovo) this.replaceChildren(nuovo); else this.replaceChildren();
    this.setAttribute("data-pronto", "");
    this.prepara(stato);
  }

  kit() { return this.querySelector("[data-gmkc]"); }

  /* Quello che il cliente ha scelto ma non ancora aggiunto: dopo un
     ridisegno deve ritrovarlo com'era. */
  leggiStato() {
    const kit = this.kit();
    if (!kit) return null;
    const s = { ancora: kit.dataset.ancora, aperto: kit.classList.contains("gmkc--aperto"), alt: null, col: {}, q: {} };
    const a = kit.querySelector("[data-alt]");
    if (a) s.alt = a.value;
    kit.querySelectorAll("[data-riga]").forEach((r) => {
      const c = r.querySelector("[data-col]");
      if (c) s.col[r.dataset.k] = c.value;
      if (r.querySelector("[data-qta]")) s.q[r.dataset.k] = r.dataset.q;
    });
    return s;
  }

  prepara(stato) {
    const kit = this.kit();
    if (!kit) return;
    this.T = leggiJSON(kit, "[data-gmkc-t]") || {};
    this.ALT = leggiJSON(kit, "[data-gmkc-alt]") || [];
    if (!stato || stato.ancora !== kit.dataset.ancora) return;

    if (stato.aperto) this.apri(kit, true);
    const a = kit.querySelector("[data-alt]");
    if (a && stato.alt && a.value !== stato.alt && !a.closest("[data-riga]").hasAttribute("data-in")) {
      a.value = stato.alt;
      this.scambia(kit, a);
    }
    kit.querySelectorAll("[data-riga]").forEach((r) => {
      const c = r.querySelector("[data-col]");
      const v = stato.col[r.dataset.k];
      if (c && v && c.value !== v && !r.hasAttribute("data-in") && Array.from(c.options).some((o) => o.value === v)) {
        c.value = v;
        this.colore(r, c);
      }
      const q = stato.q[r.dataset.k];
      if (q && r.querySelector("[data-qta]")) this.quantita(r, parseInt(q, 10));
    });
  }

  clic(e) {
    const kit = this.kit();
    if (!kit) return;
    const add = e.target.closest("[data-add]");
    if (add) { this.aggiungi(add.closest("[data-riga]"), add); return; }
    if (e.target.closest("[data-altro]")) { this.apri(kit, !kit.classList.contains("gmkc--aperto")); return; }
    const meno = e.target.closest("[data-meno]");
    const piu = e.target.closest("[data-piu]");
    if (meno || piu) {
      const r = (meno || piu).closest("[data-riga]");
      this.quantita(r, (parseInt(r.dataset.q, 10) || 1) + (piu ? 1 : -1));
    }
  }

  cambio(e) {
    const kit = this.kit();
    if (!kit) return;
    const a = e.target.closest("[data-alt]");
    if (a) { this.scambia(kit, a); return; }
    const c = e.target.closest("[data-col]");
    if (c) this.colore(c.closest("[data-riga]"), c);
  }

  apri(kit, aperto) {
    kit.classList.toggle("gmkc--aperto", aperto);
    const b = kit.querySelector("[data-altro]");
    if (!b) return;
    b.setAttribute("aria-expanded", aperto ? "true" : "false");
    const t = b.querySelector("[data-altro-txt]");
    if (t) t.textContent = aperto ? this.T.vedi_meno : this.T.vedi_altro;
  }

  quantita(r, n) {
    const q = Math.max(1, Math.min(99, n || 1));
    r.dataset.q = String(q);
    const el = r.querySelector("[data-qn]");
    if (el) el.textContent = String(q);
  }

  foto(r, src) {
    const img = r.querySelector("[data-img]");
    if (!img) return;
    if (src) { img.src = src; img.hidden = false; } else { img.removeAttribute("src"); img.hidden = true; }
  }

  /* Prezzo della riga: «ora» e, se c'e' lo sconto kit, il listino barrato
     sopra e la pastiglia rossa. was vuoto = prezzo pieno, niente barrato. */
  prezzo(r, ora, was) {
    /* «s[data-was]» e non «[data-was]»: anche le <option> del colore hanno
       data-was, e vengono prima nel DOM. */
    const p = r.querySelector("[data-prezzo]");
    const w = r.querySelector("s[data-was]");
    if (p) {
      p.textContent = ora || "";
      p.classList.toggle("gmkc__now--sconto", !!was);
    }
    if (w) { w.textContent = was || ""; w.hidden = !was; }
  }

  /* Le righe «Da abbinare» usano il prezzo scontato quando il prodotto e'
     nello sconto (pk); accessori e ricambi sempre quello pieno. */
  prezziDi(r, it) {
    if (r.dataset.ruolo === "kit" && it.pk) return { ora: it.pk, was: it.p };
    return { ora: it.p, was: "" };
  }

  stato(r, dentro, ok) {
    r.toggleAttribute("data-in", !!dentro);
    r.toggleAttribute("data-out", !dentro && !ok);
    const b = r.querySelector("[data-add]");
    if (!b) return;
    b.disabled = !!dentro || !ok;
    b.textContent = dentro ? this.T.aggiunto : ok ? this.T.aggiungi : this.T.esaurito;
  }

  colore(r, c) {
    const o = c.options[c.selectedIndex];
    if (!r || !o) return;
    r.dataset.v = o.value;
    this.prezzo(r, o.dataset.p, o.dataset.was);
    this.foto(r, o.dataset.img);
    this.stato(r, o.dataset.in === "1", o.dataset.ok === "true");
  }

  riempi(r, it) {
    if (!it) { r.setAttribute("data-vuoto", ""); return; }
    r.removeAttribute("data-vuoto");
    r.dataset.v = String(it.id);
    const nome = r.querySelector("[data-nome]");
    if (nome) nome.textContent = it.nome;
    const sub = r.querySelector("[data-sub]");
    if (sub) { sub.textContent = it.sub || ""; sub.hidden = !it.sub; }
    const pr = this.prezziDi(r, it);
    this.prezzo(r, pr.ora, pr.was);
    this.foto(r, it.img);
    this.stato(r, it.in, it.ok);
  }

  /* Un altro modello dal menu a tendina: cambia la riga, i colori, e le
     righe che dipendono da lui (la sua asta, le sue lame o catene). */
  scambia(kit, sel) {
    const A = this.ALT[sel.selectedIndex];
    if (!A) return;
    const r = sel.closest("[data-riga]");
    const vs = A.var || [];
    const v = vs.find((x) => x.in) || vs.find((x) => x.ok) || vs[0];
    const wrap = r.querySelector("[data-col-wrap]");
    const c = r.querySelector("[data-col]");
    if (c) {
      c.replaceChildren(...vs.map((x) => {
        const o = new Option(x.t, String(x.id), false, x === v);
        const pr = this.prezziDi(r, x);
        o.dataset.p = pr.ora;
        o.dataset.was = pr.was;
        o.dataset.img = x.img || "";
        o.dataset.ok = String(!!x.ok);
        o.dataset.in = x.in ? "1" : "0";
        return o;
      }));
      if (wrap) wrap.hidden = vs.length < 2;
    }
    this.riempi(r, v);
    const asta = kit.querySelector('[data-dip="asta"]');
    if (asta) this.riempi(asta, A.asta);
    kit.querySelectorAll('[data-dip="ric"]').forEach((x) => {
      this.riempi(x, (A.ric || [])[parseInt(x.dataset.slot, 10)]);
    });
  }

  async aggiungi(r, b) {
    if (!r || b.disabled) return;
    const id = parseInt(r.dataset.v, 10);
    const q = parseInt(r.dataset.q, 10) || 1;
    const err = r.querySelector("[data-err]");
    if (err) err.hidden = true;
    b.disabled = true;
    b.textContent = this.T.aggiungo;
    r.setAttribute("aria-busy", "true");
    try {
      /* _gm_kit = carrello: la riga arriva dal kit del carrello e non conta
         come «secondo attrezzo», cosi' il kit resta e si puo' fare il tris.
         Il trattino basso la nasconde al cliente nel check-out. */
      /* Formato «properties[nome]»: cart-store.js (addVariantsToCart) prende
         ogni chiave che contiene «properties» e la trasforma in proprieta';
         un oggetto { properties: {...} } finiva annidato come proprieta'
         «properties» e _gm_kit non arrivava mai. */
      await Cart.add({ id: id, quantity: q, "properties[_gm_kit]": "carrello" });
      this.stato(r, true, true);
      /* Come fa la scheda prodotto quando non deve aprire il popup: siamo
         gia' nel carrello, un avviso «aggiunto» sopra sarebbe rumore. */
      try {
        await Cart.resetLatestAddedProduct();
        await Cart.resetVariantsBeingAdded(String(id));
      } catch (e) { /* niente */ }
      /* Sulla pagina carrello si ricarica: la riga nuova disegnata dal JS del
         tema usciva senza prezzo, quantita' e sconto, e il cliente pensava che
         il kit si fosse chiuso. Ridisegnata dal server e' completa, e il kit
         resta aperto per aggiungere il terzo pezzo (tris). */
      if (document.body.classList.contains("template-cart")) {
        window.location.reload();
        return;
      }
    } catch (e) {
      b.disabled = false;
      b.textContent = this.T.aggiungi;
      if (err) { err.textContent = this.T.errore; err.hidden = false; }
    }
    r.removeAttribute("aria-busy");
  }
}

if (!customElements.get("gm-kit-carrello")) {
  customElements.define("gm-kit-carrello", GmKitCarrello);
}
